import { PaginationAdapter } from '@red/data-access';
import { createAction, props } from '@ngrx/store';
import { LookupTableModel } from '@shared/data-access/models';
import { IQuerySearch } from '@shared/data-access/interfaces';
// items
export const loadItems = createAction('[LookupTable] Load items', props<{ filters: IQuerySearch }>());
export const loadItemsSuccess = createAction('[LookupTable] Load items success', props<{ data: PaginationAdapter<LookupTableModel> }>());

// item
export const loadItem = createAction('[LookupTable] Load item', props<{ id: number }>());
export const loadItemSuccess = createAction('[LookupTable] Load item success', props<{ item: LookupTableModel }>());
